import { useReduced } from '@theme/maths'

const GROUP_SELECTOR = '[data-layout-group]'
const BUTTON_SELECTOR = '[data-layout-button]'
const STATUS_ATTRIBUTE = 'data-layout-status'
const TRANSITION_ATTRIBUTE = 'data-transitioning'
const ACTIVE_CLASS = 'is--active'

const FADE_MS = 200

/**
 * @param {HTMLElement[]} buttons
 * @param {HTMLElement} pressed
 * @returns {void}
 */
function markPressed(buttons, pressed) {
  for (const button of buttons) {
    const isActive = button === pressed
    button.classList.toggle(ACTIVE_CLASS, isActive)
    button.setAttribute('aria-pressed', String(isActive))
  }
}

/**
 * @param {HTMLElement} group
 * @returns {void}
 */
function refreshScrollables(group) {
  window.ScrollTrigger?.refresh?.()
  window.lenis?.resize?.()
  group.removeAttribute(TRANSITION_ATTRIBUTE)
}

/**
 * @param {HTMLElement} group
 * @returns {void}
 */
function initGroup(group) {
  const buttons = [...group.querySelectorAll(BUTTON_SELECTOR)].filter(
    (button) => button instanceof HTMLElement
  )
  if (buttons.length === 0) return

  let fadeOut = null
  let fadeIn = null

  /**
   * @param {HTMLElement} button
   * @param {string} layout
   * @returns {void}
   */
  const switchTo = (button, layout) => {
    markPressed(buttons, button)

    if (useReduced()) {
      group.setAttribute(STATUS_ATTRIBUTE, layout)
      refreshScrollables(group)
      return
    }

    clearTimeout(fadeOut)
    clearTimeout(fadeIn)
    group.setAttribute(TRANSITION_ATTRIBUTE, 'out')

    fadeOut = setTimeout(() => {
      group.setAttribute(STATUS_ATTRIBUTE, layout)
      fadeIn = setTimeout(() => refreshScrollables(group), FADE_MS)
    }, FADE_MS)
  }

  for (const button of buttons) {
    button.setAttribute(
      'aria-pressed',
      String(button.classList.contains(ACTIVE_CLASS))
    )
    button.addEventListener('click', () => {
      const layout = button.getAttribute('data-layout-button')
      if (!layout || group.getAttribute(STATUS_ATTRIBUTE) === layout) return
      switchTo(button, layout)
    })
  }
}

function init() {
  for (const group of document.querySelectorAll(GROUP_SELECTOR)) {
    if (group instanceof HTMLElement) initGroup(group)
  }
}

init()
